export default "__VITE_ASSET__zxaNXXXI6j0UkewQ7cz7Iw__"